import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon8",
  "use": "icon-home-item-icon8-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon8\">\n<path d=\"M3.1,2.6h13.8c0.5,0,1,0.5,1,1.1v12.7c0,0.6-0.4,1.1-1,1.1H3.1c-0.5,0-1-0.5-1-1.1V3.6C2.1,3.1,2.5,2.6,3.1,2.6z M4.1,4.6\n\tv7.9h11.9V4.6H4.1z M4.1,14.5v1h3v-1H4.1z M8,14.5v1h4v-1C12,14.5,8,14.5,8,14.5z M13,14.5v1h3v-1H13z M10,9.5c-1.1,0-2-0.9-2-2\n\ts0.9-2,2-2c1.1,0,2,0.9,2,2C12,8.6,11.1,9.5,10,9.5z M6.2,12.5c0.5-2.1,2.7-3.4,4.8-2.8c1.4,0.4,2.5,1.4,2.8,2.8H6.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon8.svg
// module id = qI2k
// module chunks = 97